import type { IScheduledTriggerPreviewRequest } from '@query'
import { ScheduledTriggerNodeConfig } from '../nodes/types'

export const DEFAULT_DAY_OF_WEEK = 1
export const DEFAULT_DAY_OF_MONTH = 1

export const normalizeScheduledTriggerConfigForPersist = (
  config: ScheduledTriggerNodeConfig
): ScheduledTriggerNodeConfig => ({
  frequency: config.frequency,
  hour: config.hour,
  minute: config.minute,
  day_of_week: config.frequency === 'weekly' ? config.day_of_week ?? DEFAULT_DAY_OF_WEEK : null,
  day_of_month: config.frequency === 'monthly' ? config.day_of_month ?? DEFAULT_DAY_OF_MONTH : null
})

export const buildScheduledTriggerPreviewPayload = (
  config: ScheduledTriggerNodeConfig
): IScheduledTriggerPreviewRequest => {
  const payload: IScheduledTriggerPreviewRequest = {
    frequency: config.frequency,
    hour: config.hour,
    minute: 0
  }
  if (config.frequency === 'weekly') {
    payload.day_of_week = config.day_of_week ?? DEFAULT_DAY_OF_WEEK
  }
  if (config.frequency === 'monthly') {
    payload.day_of_month = config.day_of_month ?? DEFAULT_DAY_OF_MONTH
  }
  return payload
}
